import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Grid } from "@material-ui/core"
import { HeaderHLPure, CheckBoxHLPure } from "../../pures"
import { MultiSelect } from "@progress/kendo-react-dropdowns"
import { RangeSlider, SliderLabel } from "@progress/kendo-react-inputs"
import "./add-survey.css"
import LabelPure from "../../pures/label/label.pure"
import SelectBranchOffices from "../../pures/target-audience/select-branch-offices"

const AddSurveyCatalogView = (props) => {
  const { t, i18n } = useTranslation()
  const { t: tCommon, ready } = useTranslation('common');
  const { consumerPreferencesSelected, setConsumerPreferencesSelected, gendersSelected, setGendersSelected, agesSelected, setAgesSelected, branchOfficesSelected, setBranchOfficesSelected, transl } = props

  const { consumerPreference, gender, branchOffice } = props.catalogInsert
  const gendersToShow = gender.map(({ name }) => name)
  const ageRanges = [0, 20, 40, 60, 80, 100]

  const onChange = (event) => {
    setConsumerPreferencesSelected([...event.value])
    setPreferencesSelected([...event.value])
  }

  const onGenderChange = (event) => {
    const { value, checked } = event.target

    if (checked && value === "Todos") {
      setGendersSelected([...gendersToShow])
    }
    else if (!checked && value === "Todos") {
      setGendersSelected([])
    }
    else {
      if (checked && !gendersSelected.includes(value)) {
        setGendersSelected([...gendersSelected, value])
      }
      else if (!checked && gendersSelected.includes(value)) {
        setGendersSelected(gendersSelected.filter(gender => gender !== value))
      }
    }
  }

  const onAgesChange = (event) => {
    const { name, value } = event.target
    setAgesSelected((prevAges) => ({
      ...prevAges,
      [name]: Math.trunc(Number(value))
    }))
  }

  const [preferences, setPreferences] = useState([])
  const [preferencesSelected, setPreferencesSelected] = useState([])

  useEffect(() => {
    if (ready) {
      if (consumerPreference) {
        const auxPreferences = consumerPreference.map((conPreference) => {
          const { name, ...rest } = conPreference
          const nameAux = tCommon(name)
          return { name: nameAux, ...rest }
        })

        setPreferences(auxPreferences)
      }

      if (consumerPreferencesSelected.length > 0) {
        const auxPreferences = consumerPreferencesSelected.map((conPreference) => {
          const selectedPreference = consumerPreference.find((item) => item.id === conPreference.id)
          const { name, ...rest } = selectedPreference
          const nameAux = tCommon(name)
          return { name: nameAux, ...rest }
        })

        setPreferencesSelected(auxPreferences)
      }
    }
  }, [i18n.language, ready])

  return (
    <Grid container spacing={2}>
      {/* Table and Header */}
      <Grid item xs={12}>
        <HeaderHLPure headingNumber={3} title={t("publicityView.addPublicityCatalog")} />
      </Grid>

      <Grid item xs={12}>
        <LabelPure title={t("publicityView.addPublicityConsumerPreference")} />
        <MultiSelect
          data={preferences}
          onChange={onChange}
          value={preferencesSelected}
          allowCustom={true}
          placeholder={transl('selectOption')}
          textField="name"
          dataItemKey="id"
        />
      </Grid>

      <Grid item xs={12}>
        <LabelPure title={t("publicityView.addPublicityGender")} />
        <div className="gender-checkboxes">
          {
            gendersToShow.map((gender) => {
              return (
                <CheckBoxHLPure
                  labelCheckBox={tCommon(gender)}
                  valueCheckBox={gender}
                  checkedState={gendersSelected.includes(gender)}
                  onChangeHandler={onGenderChange}
                />
              )
            })
          }
        </div>
      </Grid>

      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={12} md={4}>
            <LabelPure title={t("publicityView.addPublicityAge")} />
          </Grid>
          <Grid item xs={12} md={8}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <input className="age-range-input eticket-input-field"
                type="number"
                name={"start"}
                value={agesSelected.start}
                onChange={onAgesChange}
                placeholder="Min"
              />
              <input className="age-range-input eticket-input-field"
                type="number"
                name={"end"}
                value={agesSelected.end}
                onChange={onAgesChange}
                placeholder={transl('max')}
              />
            </div>
            <RangeSlider
              style={{ marginTop: '16px', width: '98%' }}
              defaultValue={agesSelected}
              step={1}
              min={0}
              max={100}
              validityStyles={true}
              onChange={(event) => setAgesSelected({
                start: Math.trunc(event.value.start),
                end: Math.trunc(event.value.end)
              })}
              value={agesSelected}
              endTabIndex={agesSelected.end}
              startTabIndex={agesSelected.start}
            >
              {ageRanges.map((perc, i) => (
                <SliderLabel
                  key={i}
                  position={perc}
                >
                  {perc.toString()}
                </SliderLabel>
              ))}
            </RangeSlider>
          </Grid>
        </Grid>
      </Grid>

      <SelectBranchOffices
        allBranchOffices={branchOffice}
        branchOfficesSelected={branchOfficesSelected}
        setBranchOfficesSelected={setBranchOfficesSelected}
        t={t}
      />
    </Grid>
  )
}

export { AddSurveyCatalogView as default }